module.exports = __webpack_public_path__ + "34736292/img/delete-icon.eb7de062.svg";